<script>
export let width;
export let linkto;
export let click;
export let image;

image = image || './images/logo.png';

function openUrl(){
    let win = window.open(linkto, '_blank');
    win.focus();
}

if(!click && linkto){ click = openUrl; }
</script>

<style>
    div {
        position: absolute;
        left: 20px;
        top: 20px;
        z-index: 999;
        cursor:pointer;
        opacity: 0.88;
    }

    img {
        height: auto;
    }

    @media only screen and (max-width: 600px) {
        img{
            max-width: 150px;
        }
    }

</style>

<div on:click={click}>
    <img src={image} width={width} alt={linkto ? 'Go to our website' : 'Load the starting scene'}/>
</div>
